import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { HERO_PORTRAIT } from "../data";

const line = {
  hidden: { y: "135%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1.05, delay: 0.3 + i * 0.14, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, 140]);
  const imgScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section
      id="top"
      ref={ref}
      className="relative min-h-screen w-full overflow-hidden pt-28 md:pt-32"
      data-testid="hero"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        {/* Text */}
        <div className="lg:col-span-7 order-2 lg:order-1">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.1, duration: 1 }}
            className="text-[11px] md:text-xs tracking-[0.35em] uppercase text-muted mb-6"
          >
            Kindermodel · Print · Laufsteg · Schauspielerin
          </motion.p>

          <div className="relative w-full h-72 sm:h-96 my-8">
            <motion.img
              src="/img/hero.png"
              alt="Janna Schwartz"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.05, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="absolute -left-5 sm:-left-9 lg:-left-12 top-0 h-full w-auto object-contain"
            />
          </div>

          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.3, duration: 1 }}
            className="mt-8 max-w-md text-base md:text-lg leading-relaxed text-stone"
          >
            Ein junges Talent mit einer ruhigen, editorialen Präsenz. Verfügbar für
            Kampagnen, Lookbooks und Laufsteg – mit Sorgfalt von ihrer Familie vertreten.
          </motion.p>
        </div>

        {/* Image */}
        <div className="lg:col-span-5 order-1 lg:order-2">
          <motion.div
            initial={{ clipPath: "inset(100% 0 0 0)" }}
            animate={{ clipPath: "inset(0% 0 0 0)" }}
            transition={{ duration: 1.3, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="relative overflow-hidden"
            style={{ borderTopLeftRadius: "9999px", borderTopRightRadius: "9999px" }}
          >
            <motion.img
              src="/img/jannahero2.jpg"
              alt="Janna Schwartz"
              style={{ y: imgY, scale: imgScale }}
              className="w-full h-[52vh] lg:h-[74vh] object-cover object-top"
              data-testid="hero-image"
            />
          </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
        className="mx-auto max-w-[1400px] px-6 md:px-10 mt-10 flex items-center justify-between text-[11px] tracking-[0.2em] uppercase text-muted"
      >
        <span>Portfolio 2026</span>
        <span className="hidden sm:inline flex items-center gap-1">
          Zum Entdecken scrollen{" "}
          <motion.span
            className="inline-block"
            animate={{ y: [0, 4, 0] }}
            transition={{
              repeat: Infinity,
              duration: 2,
              ease: "easeInOut",
            }}
          >
            ↓
          </motion.span>
        </span>
      </motion.div>
    </section>
  );
}
